import {
	Button,
	Checkbox,
	Col,
	Form,
	Input,
	InputNumber,
	Radio,
	Row,
	Select,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import {
	customerTypeOptions,
	notifiableOptions,
	paymentTermOptions,
	paymentTypeOptions,
	quadrantTypeOptions,
} from "../../constants/Customer";
import { useLocation } from "react-router-dom";

const { Option } = Select;

const NewProspectPre = ({ history }) => {
	const location = useLocation();
	const { sellerId } = location.state || {};
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const [contactType, setContactType] = useState("Email");
	const [sellerOptions, setSellerOptions] = useState([]);
	const [sellerDisabled, setSellerDisabled] = useState();
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getValues();
	}, []);

	const getValues = async () => {
		await Promise.all([getSellerList()]).then(() => {
			setLoading(false);
		});
	};

	const getSellerList = async () => {
		const url = api + "/user/list/57Concrete/Seller";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						value: item._id,
						label: item.name,
					});
				});
				setSellerOptions(list);
				if (sellerId) {
					const currentSeller = list.find(
						(seller) => seller.value === sellerId,
					);
					if (currentSeller) {
						form.setFieldsValue({
							prospectionSeller: currentSeller.value,
						});
					} else {
						form.setFieldsValue({
							prospectionSeller: undefined,
						});
					}
					const email = localStorage.getItem("email");

					if (
						email === "eliud@gmail.com" ||
						email === "ec@57concrete.com" ||
						email === "pc@57concrete.com" ||
						email === "jc@57concrete.com" ||
						email === "gg@57xgroup.com" ||
						email === "rl@57concrete.com" ||
						email === "jh@57concrete.com" ||
						email === "bpa@57concrete.com"
					) {
						setSellerDisabled(false);
					} else {
						setSellerDisabled(true);
					}
				} else {
					setSellerDisabled(false);
				}
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const duplicatedUserPhone = async (phone) => {
		const url = api + `/userphone/+1${phone}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			return data.found;
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const createCompany = async (datas) => {
		try {
			const company = {
				name: datas.companyName,
				contactPhone: datas.contactPhone,
				prospectionSeller: datas.prospectionSeller,
				franchise: "57Concrete",
				createdBy: localStorage.getItem("userId"),
				prospectionType: "Prospect",
				registrationComplete: false,
			};

			const url = api + "/customer";

			await axios.post(url, company);
			openNotification("success", "Success", "Prospect created");
			setTimeout(() => {
				setLoading(false);
				history.push(`/prospect/dashboard`);
			}, 2000);
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to create customer prospect",
			);
			console.error(err);
			return null;
		}
	};

	const validateUser = async (values) => {
		const duplicadoPhone = await duplicatedUserPhone(values.contactPhone);
		if (duplicadoPhone) {
			openNotification(
				"warning",
				"Duplicated user",
				"User already exist with Phone",
			);
			setLoading(false);
		} else {
			createCompany(values);
		}
	};

	const onChangeContactType = (e) => {
		setContactType(e.target.value);
	};

	const onFinish = (values) => {
		setLoading(true);
		validateUser(values);
	};

	const prefixSelector = (
		<Form.Item name="prefix" noStyle>
			<Select
				style={{
					width: 70,
				}}
			>
				<Option value="+1">+1</Option>
			</Select>
		</Form.Item>
	);

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={{
					prefix: "+1",
					contactType: "Email",
					paymentType: "PrePay",
					paymentTerm: "Prepayment",
					creditRequested: false,
					state: "TX",
					creditAmount: 0,
					contactFax: "",
					accountsPayableFax: "",
					accountsPayableEmail: "",
					notifiableEvents: ["newJob", "newLoad"],
				}}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Company Name"
							name="companyName"
							rules={[
								{
									required: true,
									message: "Please fill company name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Customer Type" name="customerType">
							<Select
								showSearch
								placeholder={`Select customer type`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={customerTypeOptions}
								style={{
									width: "100%",
								}}
								disabled
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Quadrant Type" name="quadrantType">
							<Select
								showSearch
								placeholder={`Select quadrant type`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={quadrantTypeOptions}
								style={{
									width: "100%",
								}}
								disabled
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Contact Name" name="name">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Contact Phone"
							name="contactPhone"
							rules={[
								{
									required: true,
									message: "Please fill phone",
								},
								{
									len: 10,
									max: 10,
									message: "Phone number must have 10 numbers",
								},
							]}
						>
							<Input size="large" addonBefore={prefixSelector} />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={4}>
						<Form.Item name="contactType" label="Contact Type">
							<Radio.Group onChange={onChangeContactType} size="large" disabled>
								<Radio.Button value="SMS">SMS</Radio.Button>
								<Radio.Button value="Email">Email</Radio.Button>
							</Radio.Group>
						</Form.Item>
					</Col>
					{contactType === "Email" ? (
						<Col span={20}>
							<Form.Item label="Contact Email" name="email">
								<Input size="large" disabled />
							</Form.Item>
						</Col>
					) : (
						<Col span={20}>
							<Form.Item label="Customer Phone" name="sms">
								<Input size="large" addonBefore={prefixSelector} disabled />
							</Form.Item>
						</Col>
					)}
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item label="Notifiable Events" name="notifiableEvents">
							<Select
								showSearch
								labelInValue
								placeholder={`Select notifiable events`}
								size="large"
								mode="multiple"
								options={notifiableOptions}
								style={{
									width: "100%",
								}}
								disabled
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item label="Company Address" name="address">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Company City" name="city">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Company State" name="state">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Company ZIP" name="zip">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Contact Fax Number" name="contactFax">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="A/P Contact Name" name="accountsPayableContact">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="A/P Contact Email" name="accountsPayableEmail">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="A/P Contact Phone" name="accountsPayablePhone">
							<Input size="large" addonBefore={prefixSelector} disabled />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="A/P Contact Fax" name="accountsPayableFax">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Payment Type" name="paymentType">
							<Select
								showSearch
								placeholder={`Select payment type`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={paymentTypeOptions}
								style={{
									width: "100%",
								}}
								disabled
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Payment Term" name="paymentTerm">
							<Select
								showSearch
								placeholder={`Select payment term`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={paymentTermOptions}
								style={{
									width: "100%",
								}}
								disabled
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Credit Amount" name="creditAmount">
							<InputNumber size="large" style={{ width: "100%" }} disabled />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Seller"
							name="prospectionSeller"
							rules={[
								{
									required: true,
									message: "Please select seller",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select payment seller`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={sellerOptions}
								style={{
									width: "100%",
								}}
								disabled={sellerDisabled}
							/>
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={12}>
						<Form.Item name="creditRequested" valuePropName="checked">
							<Checkbox disabled>Request Credit</Checkbox>
						</Form.Item>
					</Col>
				</Row>
				<Button type="primary" htmlType="submit" loading={loading} size="large">
					Create
				</Button>
			</Form>
		);
	};

	return (
		<Layout
			title="New Prospect PRE"
			description="Create new Prospect"
			type="medium"
		>
			{contextHolder}
			<CustomForm />
		</Layout>
	);
};

export default NewProspectPre;
